import { createSelector } from 'reselect'

import { selectCockpitFilterPbm } from './selectCockpitFilterPbm'
import { selectCockpitPbmUsers } from './selectCockpitPbmUsers'

const EMPTY_USERS: never[] = []

export const selectCockpitPbmUsersForFiltering = createSelector(
  [selectCockpitFilterPbm, selectCockpitPbmUsers],
  (selectedPbm, users) => (selectedPbm.length ? users : EMPTY_USERS)
)
